import React, { useState, useEffect, useRef, useContext } from 'react';

import buildSpellbook from './helpers/buildSpellbook';
import { rollDie } from '..//../helpers/rollDice'
import GET_ALL_SPELLS from './helpers/getAllSpells';
import { sanitizeSpellDescription } from '../../helpers/sanitizeInput.js'

  import { UserDataContext } from "../../App.js";

import './Spellbook.css'

const Spellbook = ( props ) => {


  // imported state variables
  const globalState = props.state;
  const data = props.data;
  const setData = props.setdata;
  const [userData, setUserData] = useContext(UserDataContext);
  const [activeView, setActiveView] = props.activeViewArray;


  // local state variables
  const [spells, setSpells] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [classFilter, setClassFilter] = useState( data.myClass || 'Mage');
  const [levelFilter, setLevelFilter] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [showAll, setShowAll] = useState(true);
  const [spellbook, setSpellbook ] = useState([]);
  const [failedSpells, setFailedSpells ] = useState([]);

  const previousMyClassRef = useRef(data.myClass || 'Mage');
  const previousMyAllRef = useRef(true);


  // Fetch spells from API
  const fetchSpells = async () => {
    setLoading(true);
    setError('');
    const data = await GET_ALL_SPELLS(undefined, 'Spellbook');
    if (Array.isArray(data) && data.length > 0) {
      setSpells(data);
      setLoading(false);
    } else {
      setLoading(false);
      setError('Failed to load spells. Please try again later.');
    }
  };

  // Initial fetch
  useEffect(() => {
    fetchSpells();
  }, []);

  // Rebuild spellbook when data changes
  useEffect( () => {
  console.log('spellbook props', props )
  console.log(userData)
    async function getSpellbook ( ) {
    const receivedSpellBook = await buildSpellbook( data, globalState, setSpellbook);
    console.log('received spellbook: ', receivedSpellBook)
    if (receivedSpellBook.length  > 0) {
      setShowAll(previousMyAllRef);
      const firstSpellClass = receivedSpellBook[0].Class
      console.log( firstSpellClass, previousMyClassRef )
      if (previousMyClassRef.current !== firstSpellClass) {
        setClassFilter(firstSpellClass)
        setLevelFilter('');
        setShowAll(false);
        setCurrentIndex(0);
        previousMyClassRef.current = firstSpellClass;
      }
    }
    }
    getSpellbook()
  }, [data, globalState]);


  // Get unique classes for filter
  const classes = [...new Set(spells.map(spell => spell.Class))];

  // Filter spells
  const filteredSpells = spells.filter(spell => {
  const matchesClassFilter = !classFilter || spell.Class === classFilter;
  const matchesLevelFilter = !levelFilter || spell.Lvl == levelFilter;
  const matchesSpellbook = showAll || (spellbook?.length > 0 && spellbook.some(spellItem => spellItem.Name === spell.Name));

  return matchesClassFilter && matchesLevelFilter && matchesSpellbook;
});

  // Update spell display
  const currentSpell = filteredSpells[currentIndex] || {};

  // Navigation functions
  const prevSpell = () => {
    if (filteredSpells.length === 0) return;
    setCurrentIndex((currentIndex - 1 + filteredSpells.length) % filteredSpells.length);
  };

  const nextSpell = () => {
    if (filteredSpells.length === 0) return;
    setCurrentIndex((currentIndex + 1) % filteredSpells.length);
  };

// ----- HANDLE ADD TO SPELLBOOK -----
const handleAddToSpellBook = (event) => {

    const spellName = currentSpell.Name;
    const spellLevel = currentSpell.Lvl;
    const spellKeyPrefix = `mySp`; // e.g., mySp11 for level 1 spells

  if (event.target.checked) {

    let added = false; // Track whether a spell slot was successfully added

    for (let i = 1; i <= 30; i++) {
      // v0.5
      const spellIndex = String(spellLevel) + String(i).padStart(2, '0')

      const spellAtIndex = data[`${spellKeyPrefix}${spellIndex}`]

      console.log(`${spellKeyPrefix}${spellIndex} = ${spellAtIndex}`);

      if ( spellAtIndex === '' || spellAtIndex === undefined) {

        let rollToLearn = null
        let rollText = ""
        
        if (currentSpell.Class === 'Mage' || currentSpell.Class === 'Illusion') {
            const chanceToLearn = parseInt(data.myIntBon.match(/\d+/)?.[0], 10) || 0;

           rollToLearn = window.confirm(`you have a ${chanceToLearn}% chance to learn. OK to roll or Cancel to skip`)

            let rollText
            if ( rollToLearn ) {
              const roll = rollDie(100);
              rollText = `You rolled ${roll}`
              console.log(rollText)
              
              if (roll > chanceToLearn ) {
              alert (`${rollText} and were unable to learn the spell`)
              setFailedSpells([spellName, ...failedSpells])
              return
              }
              
            }
        }

        setData({
          ...data,
          [`${spellKeyPrefix}${spellIndex}`]: spellName,
        });

        if ( rollToLearn ) {
          alert(`Success. ${rollText}. Added to spell slot ${spellKeyPrefix}${spellIndex}`)
        } else {
        alert(`Added to spell slot ${spellKeyPrefix}${spellIndex}`);
        }
        added = true; // Mark as added
        break;

      }
    }

    if (!added) {
      alert('Unable to add - no free slots found');
    }

  // ----- REMOVE FROM SPELLBOOK -----
  } else {
      for (let i = 1; i <= 30; i++) {

          const spellIndex = String(spellLevel) + String(i).padStart(2, '0')

          const spellKey = `${spellKeyPrefix}${spellIndex}`

          console.log( data[spellKey], spellName )
          if (data[spellKey] === spellName ) {

            const confirmDelete = window.confirm(`Remove from ${spellKey}?`)
            if ( confirmDelete ) {
                setData({
                  ...data,
                  [`${spellKeyPrefix}${spellIndex}`]: "",
                });

            }
            return;
          }
        }
    alert('Unable to find. Remove manually');
  }
};

// ----- HANDLE CLOSE -----
const handleClose = (event) => {
  setActiveView('charsheet')
}

  return (
  <>
    <div className="spellbook2-background">
    <div className='spellbook2-charname'>{data.name}'s Spellbook
    <span><button className='spellbook2-close-button' onClick={handleClose}>X</button></span>
    </div>
      <div className="spellbook2-container" style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
        <div className='spellbook2-select-container'>
        <button id="spellbook2-mobile-close" className='spellbook2-close-button' onClick={handleClose}>X</button>
          <select
            className="spellbook2-select"
            id='spellbook2-class-select'
            
            value={classFilter}
            onChange={(e) => { setClassFilter(e.target.value); setCurrentIndex(0); }}
          >
            <option value="">All Classes</option>
            {classes.map(cls => (
              <option key={cls} value={cls}>{cls}</option>
            ))}
          </select>
          <select
            className="spellbook2-select"
            id='spellbook2-level-select'
            value={levelFilter}
            onChange={(e) => { console.log(e.target.value); setLevelFilter(e.target.value); setCurrentIndex(0); }}
          >
            <option value="">All Levels</option>
            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map(level => (
              <option key={level} value={level}>{level}</option>
            ))}
          </select>
          <button
            className="spellbook2-nav-button"
            onClick={prevSpell}
          >
            ◀
          </button>
          <button
            className="spellbook2-nav-button"
            onClick={nextSpell}
          >
            ▶
          </button>
        </div>

        <div className='spellbook2-modify-row'>
          <div id="spellbook2-show-all">Show All 
          <input 
            type='checkbox'
            checked={showAll}
            onChange={(e) => { setShowAll(e.target.checked); previousMyAllRef.current = e.target.checked; } }
          /></div>
          <div id="spellbook2-add">In Spellbook
          <input
            id='in-spellbook-checkbox' 
            type='checkbox'
            checked={spellbook?.some(spellItem => spellItem.Name === currentSpell.Name)}
            onChange={(e) => handleAddToSpellBook(e) }
          /></div>
        </div>

        <div className="spellbook2-error" style={{ color: 'red' }}>{error}</div>
        <div className="spellbook2-loading" style={{ color: '#666' }}>
          {loading ? 'Loading spells...' : ''}
        </div>
        <div
          className="spellbook2-spell-card"
          style={{
            display: filteredSpells.length > 0 ? 'block' : 'none'
          }}
        >
        <h2
          className="spellbook2-spell-name"
          style={failedSpells.includes(currentSpell.Name) ? { color: '#d10e0e' } : undefined}
        >
          {currentSpell.Name || 'N/A'}
        </h2>
          <p className="spellbook2-spell-info" style={{ margin: '5px 0' }}>
            <strong>Casting Time:</strong> <span>{currentSpell.Casting || 'N/A'}</span>
          </p>
          <p className="spellbook2-spell-info" style={{ margin: '5px 0' }}>
            <strong>Save:</strong> <span>{currentSpell.Save || 'N/A'}</span>
          </p>
          <p className="spellbook2-spell-info" style={{ margin: '5px 0' }}>
            <strong>Range:</strong> <span>{currentSpell.Range || 'N/A'}</span>
          </p>
          <p className="spellbook2-spell-info" style={{ margin: '5px 0' }}>
            <strong>Duration:</strong> <span>{currentSpell.Duration || 'N/A'}</span>
          </p>
          <p className="spellbook2-spell-info" style={{ margin: '5px 0' }}>
            <strong>Area of Effect:</strong> <span>{currentSpell.AOE || 'N/A'}</span>
          </p>
          { levelFilter && levelFilter !== '' && levelFilter !== 'All Levels' ? null : (
            <p className="spellbook2-spell-info" style={{ margin: '5px 0' }}>
              <strong>Level:</strong> <span>{currentSpell.Lvl || 'N/A'}</span>
            </p>
          ) }
      {/*
          <p className="spellbook2-spell-info" style={{ margin: '5px 0' }}>
            <strong>School:</strong> <span>{currentSpell.School || 'N/A'}</span>
          </p>
          <p className="spellbook2-spell-info" style={{ margin: '5px 0' }}>
            <strong>Components:</strong> <span>{currentSpell.Comps || 'N/A'}</span>
          </p>
      */}
          <p className="spellbook2-spell-info" style={{ margin: '5px 0' }}>
            <strong>Effect:</strong> <span>{currentSpell.Effect || 'N/A'}</span>
          </p>
          <div
            className="spellbook2-description"
            style={{ marginTop: '15px' }}
            dangerouslySetInnerHTML={{ __html: sanitizeSpellDescription((currentSpell.Description || '').replace(/\n/g, '<br>')) }}
          />
        </div>
      </div> 
    </div>
    </>
  );
};

export default Spellbook;